export default {
      id: "i-presentation-usage",
      viewBox: "0 0 41 36",
      url: __webpack_public_path__ + "img/sprite.svg#i-presentation",
      toString: function () {
        return this.url;
      }
    }